<!-- MFITT Wrapperメンテナンス中のダイアログ -->
<template>
  <ItemDialog ref="duringMaintenance" image-type="alert">
    <template #content-area>
      <h2 v-if="isNoAvailableTime">照会可能時間外のためご利用できません</h2>
      <p v-else class="text-center">ただ今メンテナンス中です。</p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogDuringMaintenance",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const duringMaintenance = ref(null);
    const isNoAvailableTime = ref(false);

    const openDialog = (error) => {
      // error_codeに応じて文言を出し分ける
      isNoAvailableTime.value = error.error_code == "no_available_time";
      duringMaintenance.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        // トップページへ戻る
        nativeHandlerService.returnNativeAppMfittIndexPage();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      isNoAvailableTime,
      duringMaintenance,
      openDialog,
      closeDialog,
    };
  },
};
</script>
